import { InputLabel, Stack, Typography } from '@mui/material'
import { C1CheckboxPrettyDisplay } from 'components/core/checkbox'
import { ExternalLink } from 'components/core/links/external-link'
import { FormattedMessage } from 'react-intl'

export type AcceptedTermsProps = { acceptedTerms: boolean | undefined, setAcceptedTerms: (value: boolean) => void }

export const AcceptedTerms = ({
    acceptedTerms,
    setAcceptedTerms,
}: AcceptedTermsProps): React.ReactElement => {
    return <Stack spacing={1}>
        <InputLabel htmlFor="accepted-terms">
            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                <FormattedMessage
                    id="terms_and_conditions"
                    defaultMessage="Terms and conditions"
                />
            </Typography>
        </InputLabel>
        <C1CheckboxPrettyDisplay
            id="accepted-terms"
            label={
                <Typography variant="caption">
                    <FormattedMessage
                        id="accepted_terms_label"
                        defaultMessage="Unless otherwise agreed to in a signed agreement, I have read and agree to the <msa>Master Service Agreement</msa> and the <privacy>Privacy Policy</privacy>."
                        values={{
                            msa: (chunks) => <ExternalLink href="https://www.conductorone.com/legal/msa/">{chunks}</ExternalLink>,
                            privacy: (chunks) => <ExternalLink href="https://www.conductorone.com/privacy-policy/">{chunks}</ExternalLink>,
                        }}
                    />
                </Typography>
            }
            color="primary"
            checked={acceptedTerms}
            onChange={(checkbox): void => {
                setAcceptedTerms(checkbox.target.checked)
            }}
        />
    </Stack>
}
